


const Image = ({ref,src,className,type="user",style,onClick,id}) => {

return (
    <><img ref={ref} id={id} className={className + " object-cover"} style={style} src={src ? (Array.isArray( src) ?src[0]:src  ) :  process.env.REACT_APP_MFTC_SERVER_URL_FILES + "medias/"+type+".png"  } onClick={onClick}   alt={type} crossOrigin="anonymous"/></>
)
}
export default Image